import { notificationService } from '@/lib/services/notification.service';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { submitNACBIntake, type SubmitNACBIntakeDto } from '../api/nacb-intake.api';

export function useNACBIntakeMutation() {
  const { t } = useTranslation('common');

  const submitMutation = useMutation({
    mutationFn: (body: SubmitNACBIntakeDto) => submitNACBIntake(body),
    onSuccess: () => {
      notificationService.showSuccess(t('nacbIntake.useNacbIntakeMutation.theTriggerIntakeForm'));
    },
    onError: (error) => {
      const message =
        error instanceof Error
          ? error.message
          : t('nacbIntake.useNacbIntakeMutation.failedToSubmitForm');
      notificationService.showError(
        t('nacbIntake.useNacbIntakeMutation.failedToSubmitIntake', { message }),
      );
    },
  });

  return {
    submit: submitMutation.mutateAsync,
    isSubmitting: submitMutation.isPending,
    isSuccess: submitMutation.isSuccess,
    error: submitMutation.error,
    reset: submitMutation.reset,
  };
}
